"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permission = void 0;
var Permission = exports.Permission = /*#__PURE__*/function (Permission) {
  Permission["UPLOAD_FILES"] = "UIHomePage:UploadFilesButton";
  Permission["ADD_FOLDER"] = "UIHomePage:AddFolderButton";
  Permission["IMPORT_TEAMS"] = "UIHomePage:ImportTeamsButton";
  Permission["DELETE"] = "UIHomePage:DeleteButton";
  Permission["MOVE_TO_FOLDER"] = "UIHomePage:MoveToFolderButton";
  Permission["DOWNLOAD"] = "UIHomePage:DownloadButton";
  Permission["CHECKBOXES"] = "UIHomePage:CheckBoxes";
  Permission["FOLDER_ACTION_RENAME"] = "UIActionsFolder:Rename";
  Permission["FOLDER_ACTION_DOWNLOAD"] = "UIActionsFolder:Download";
  Permission["FOLDER_ACTION_MOVE_TO"] = "UIActionsFolder:MoveTo";
  Permission["FOLDER_ACTION_DELETE"] = "UIActionsFolder:Delete";
  Permission["FILE_ACTION_EDIT"] = "UIActionsFile:Edit";
  Permission["FILE_ACTION_UPDATE_VERSION"] = "UIActionsFile:UpdateVersion";
  Permission["FILE_ACTION_DOWNLOAD"] = "UIActionsFile:Download";
  Permission["FILE_ACTION_MOVE_TO"] = "UIActionsFile:MoveTo";
  Permission["FILE_ACTION_DELETE"] = "UIActionsFile:Delete";
  Permission["VIEWER_EDIT"] = "UIViewer:Edit";
  Permission["VIEWER_DOWNLOAD"] = "UIViewer:Download";
  Permission["VIEWER_UPDATE"] = "UIViewer:Update";
  Permission["VIEWER_DELETE"] = "UIViewer:Delete";
  Permission["VIEWER_SUMMARY"] = "UIViewer:Summary";
  return Permission;
}({});